import React from 'react';
import PropTypes from 'prop-types';
import TranslationContainer from '../../../translation/translation_container';
import { LightboxView } from './view_sections/lightbox_view';
import { LightboxViewHeadline } from './view_sections/lightbox_view_headline';
import { LightboxViewContent } from './view_sections/lightbox_view_content';
import { LightboxViewAction } from './view_sections/view_actions/lightbox_view_action'; 
import { LightboxVehicleFilterSelect } from './filters/lightbox_vehicle_filter_select';
import { FilterSections } from '../../../../constants/filter/filter_sections';
import { Filters } from '../../../../constants/filter/filters';
import { FilterSectionLabelTranslationKeys } from '../../../../constants/filter/filter_section_label_translation_keys';
import { FilterLabelTranslationKeys } from '../../../../constants/filter/filter_label_translation_keys';

function LightboxVehicleTyres(props) {
    const sectionHeadlineTranslationKey = FilterSectionLabelTranslationKeys[FilterSections.FITMENT_VIEW];
    const vehicleTypeTranslationKey = FilterLabelTranslationKeys[Filters.VEHICLE_TYRES];

    return (
        <LightboxView
            viewName={FilterSections.FITMENT_VIEW}
            opened={props.opened}
        >
            <TranslationContainer translationKey={sectionHeadlineTranslationKey} targetProperty="headline">
                <LightboxViewHeadline headline="will-be-replaced" />
            </TranslationContainer>
            <LightboxViewContent>
                <LightboxVehicleFilterSelect
                    name={Filters.VEHICLE_TYRES}
                    labelTranslationKey={vehicleTypeTranslationKey}
                    provideAllTranslationKey={'vehicle-configurator-tyres-select-label'}
                    onChange={props.onChange}
                    provideAllOption={false}
                />
            </LightboxViewContent>
            <LightboxViewAction
                onCloseClick={props.resetSection}
                onSaveClick={props.resetSection}
            />
        </LightboxView>
    );
}

LightboxVehicleTyres.propTypes = {
    onChange: PropTypes.func.isRequired,
    resetSection: PropTypes.func.isRequired,
    saveSection: PropTypes.func.isRequired,
    opened: PropTypes.bool.isRequired,
};

export { LightboxVehicleTyres };
